import React, { useState } from 'react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Send, Loader2, Link as LinkIcon } from 'lucide-react';
import { updateAPI } from '../lib/api';
import { useTranslation } from '../context/LanguageContext';
import { toast } from 'sonner';

export function UpdateComposer({ userProjects = [], onUpdateCreated }) {
  const { t } = useTranslation();
  const [content, setContent] = useState('');
  const [projectId, setProjectId] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;

    setLoading(true);
    try {
      const data = { content: content.trim() };
      if (projectId) data.project_id = projectId;
      const res = await updateAPI.create(data);
      toast.success('Update posted!');
      setContent('');
      setProjectId('');
      onUpdateCreated?.(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to post update');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-slate-200 p-5 mb-6">
      <Textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={t('component.shareUpdate')}
        className="min-h-[100px] resize-none border-slate-200 focus:ring-orange-500/20 mb-3"
        maxLength={2000}
      />

      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 flex-1">
          {userProjects.length > 0 && (
            <Select value={projectId} onValueChange={setProjectId}>
              <SelectTrigger className="w-[200px] text-sm">
                <LinkIcon className="w-3.5 h-3.5 mr-1 text-slate-400" />
                <SelectValue placeholder={t('component.selectProject')} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="">{t('component.noProject')}</SelectItem>
                {userProjects.map((p) => (
                  <SelectItem key={p.project_id} value={p.project_id}>
                    {p.title}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
          <span className="text-xs text-slate-400 ml-auto">
            {content.length}/2000
          </span>
        </div>

        <Button
          type="submit"
          disabled={loading || !content.trim()}
          className="btn-boost text-sm"
        >
          {loading ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <>
              <Send className="w-4 h-4 mr-1" />
              {t('component.postUpdate')}
            </>
          )}
        </Button>
      </div>
    </form>
  );
}
